module.exports = __webpack_public_path__ + "static/img/Band_nato_norm.44a5d41.png";